import React, { ChangeEvent } from 'react';
import { limitDateTo } from 'utils/Date';
import { IPeriodDateProps } from './interface';

const PeriodDateToInput: React.FC<IPeriodDateProps> = ({
  period,
  setNewData,
  setPeriod,
  onBlur,
  placeHolder,
  className,
  style,
  id
 }: IPeriodDateProps) => {

  const handleDate = (e: ChangeEvent<HTMLInputElement>) => {
    limitDateTo(period, e.target.value, setPeriod);

    if (setNewData) {
      setNewData('start');
    }
  };
  return (
    <input
      value={period.to}
      onChange={(event) =>  handleDate(event)}
      className={className}
      style={style}
      type="date"
      min={period.from}
      placeholder={placeHolder}
      onBlur={() => {
        if (onBlur) {
          onBlur();
        }
      }}
      id={id}
    />
  );
}

export default PeriodDateToInput;